export const cateringDashboardWidgets = [
    {
        id: 1,
        label: 'Inquires to reach out',
        value: 'inquiryToReachOut',
        displayByDefault: true,
        timeline: 'all',
        additionalField: 'Submission',
        additionalKey: 'submissionTimestamp',
    },
    {
        id: 2,
        label: 'Inquiries to follow-up',
        value: 'inquiryToFollowUp',
        displayByDefault: true,
        timeline: 'all',
        additionalField: 'Follow up by',
        additionalKey: 'followupDueDate',
    },
    {
        id: 3,
        label: 'Confirmed Upcoming Event',
        value: 'confirmedUpcoming',
        displayByDefault: true,
        timeline: 'all',
        additionalField: 'Other',
        additionalKey: 'eventType',
    },
    {
        id: 4,
        label: 'Confirmed Upcoming Event - Today',
        value: 'confirmedUpcomingToday',
        displayByDefault: false,
        timeline: 'all',
        additionalField: 'Other',
        additionalKey: 'eventType',
    },
    {
        id: 5,
        label: 'Confirmed Upcoming Event - Tomorrow',
        value: 'confirmedUpcomingTomorrow',
        displayByDefault: false,
        timeline: 'all',
        additionalField: 'Other',
        additionalKey: 'eventType',
    },
    {
        id: 6,
        label: 'Confirmed Upcoming Event - Deposit Pending',
        value: 'confirmedUpcomingDepositPending',
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
    {
        id: 7,
        label: 'Confirmed Upcoming Event - Deposit Paid',
        value: 'confirmedUpcomingDepositPaid',
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
    {
        id: 8,
        label: 'Confirmed  Upcoming Event  - Invoice Pending',
        value: 'confirmedUpcomingInvoicePending',
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
    {
        id: 9,
        label: 'Confirmed Upcoming Event  - Invoice Paid',
        value: 'confirmedUpcomingInvoicePaid',
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
    {
        id: 10,
        label: 'Recent Past Events',
        value: 'recentPast',
        displayByDefault: true,
        timeline: 'all',
        additionalField: 'Other',
        additionalKey: 'eventType',
    },
    {
        id: 11,
        label: 'Recent Past Events - Invoice Pending',
        value: 'recentPastInvoicePending',
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
    {
        id: 12,
        label: 'Recent Past Events - Invoice Paid',
        value: 'recentPastInvoicePaid',
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
    {
        id: 13,
        label: 'Void Events',
        value: 'void',
        displayByDefault: true,
        timeline: 'all',
        additionalField: null,
        additionalKey: null,
    },
];
